import { cn } from '../../lib/cn'

interface SkeletonProps {
  className?: string
}

/** Warm placeholder block (design-system: elevation is light — surfaces, not gray boxes). */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('fireside-shimmer rounded-control bg-surface-raised/70', className)}
    />
  )
}

interface SkeletonGroupProps {
  label?: string
  className?: string
  children: React.ReactNode
}

/** Groups skeletons under one polite live-region announcement. */
export function SkeletonGroup({ label = 'Loading…', className, children }: SkeletonGroupProps) {
  return (
    <div role="status" className={className}>
      <span className="sr-only">{label}</span>
      {children}
    </div>
  )
}
